import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router";

import { Grid, Shelf, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Title } from "capitalrx-components-2.0/lib/typography";

import { ThemedButton } from "@/common/components/themed";
import { PaymentSummaryPanel } from "@/premium/pages/Pharmacies/PharmacyDetails/PaymentSummaryPanel";
import { PharmacyDetailsPanel } from "@/premium/pages/Pharmacies/PharmacyDetails/PharmacyDetailsPanel";
import { PrescriptionDetailsPanel } from "@/premium/pages/Pharmacies/PharmacyDetails/PrescriptionDetailsPanel";
import { Breadcrumbs, Card, PageLayout } from "@/premium/themedComponents";

import "./PharmacyDetailsPage.scss";

export const PharmacyDetailsPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t: translate } = useTranslation();

  const goBackToSearchPage = () => {
    navigate(-1);
  };

  const drug_name = searchParams.get("drugName");

  const { halfColumns } = useResponsive({
    halfColumns: { desktop: 6, tablet: 6, mobile: 12 },
  });

  return (
    <PageLayout>
      <Stack>
        <Breadcrumbs />
        <Stack spacing="large">
          <Stack spacing="mini">
            <Shelf>
              <ThemedButton className="back-button" appearance="text" icon="arrow-left" onClick={goBackToSearchPage}>
                {translate("BUTTONS.backButton.back")}
              </ThemedButton>
              <Shelf.Spacer />
            </Shelf>
            <Shelf>
              <Title>{drug_name}</Title>
              <Shelf.Spacer />
            </Shelf>
          </Stack>
          <Card>
            <Grid>
              <Grid.Span columns={halfColumns}>
                <Stack spacing="large">
                  <PaymentSummaryPanel />
                  <PrescriptionDetailsPanel />
                </Stack>
              </Grid.Span>
              <Grid.Span columns={halfColumns}>
                <PharmacyDetailsPanel />
              </Grid.Span>
            </Grid>
          </Card>
        </Stack>
      </Stack>
    </PageLayout>
  );
};
